import { createFilterOptions } from "@material-ui/lab";
import { useSelector } from "react-redux";
import React from "react";
import styled from "styled-components/macro";
import { getGlobalBusinesses } from "selectors";
import { EMPTY_OBJECT } from "lib";
import { Autocomplete, withNamespace } from "components/Form/FormikControls";

const GlobalBusinessContainer = styled.div`
  flex-grow: 1;
  min-width: 250px;
`;
const filterOptions = createFilterOptions();

export interface GlobalBusinessDataSourceField {
  source: "GLOBAL_BUSINESS";
  value: string;
}

interface GlobalBusinessDataSourceProps {
  // The namespace of the field
  namespace: string;

  // The data-tour attribute for the component
  dataTour?: string;
}

export function GlobalBusinessDataSource(props: GlobalBusinessDataSourceProps) {
  const { namespace: ns, dataTour } = props;

  const businesses = useSelector(getGlobalBusinesses) || EMPTY_OBJECT;

  const name = withNamespace(ns, "value");

  const options = Object.values(businesses);

  return (
    <GlobalBusinessContainer>
      <Autocomplete
        className="p-2"
        data-tour={`${dataTour}Value`}
        getOptionValue={option => `${option.id}`}
        getOptionLabel={option => option.name || ""}
        filterOptions={filterOptions}
        name={name}
        options={options}
      />
    </GlobalBusinessContainer>
  );
}
